module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.errors), function(e, index) {
    return _c('ui-alert', {
      key: index,
      attrs: {
        "type": "error",
        "dismissible": false
      }
    }, [_vm._v(_vm._s(e))])
  }), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Adres url")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Adres url",
      "name": "url",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz adres url"
    },
    on: {
      "change": _vm.changed
    },
    model: {
      value: (_vm.url),
      callback: function($$v) {
        _vm.url = $$v
      },
      expression: "url"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Podgląd treści")]), _vm._v(" "), (_vm.iframeUrl) ? _c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "width": "100%",
      "height": "300px;",
      "src": _vm.iframeUrl
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.url
    }
  }, [_vm._v("Wybierz")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68b54758","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/messages/UrlPreviewForm.vue
// module id = 268
// module chunks = 0